<template>
    <div class="add-mumbl-card container">
        <div class="card">
            <div class="card-content">
                <h3 class="center-align white-text">Add a Mumbl Card</h3>

                <form id="form" @submit.prevent="addMumblCard">
                    <div class="field">
                        <label for="name">
                            Name
                        </label>
                        <input type="text" name="name" v-model='name'>
                    </div>

                    <div class="field">
                        <label for="origin">
                            Origin
                        </label>
                        <input type="text" name="origin" v-model='origin'>
                    </div>

                    <div class="field">
                        <label for="meaning">
                            Meaning
                        </label>
                        <textarea class="materialize-textarea" name="meaning" v-model='meaning'></textarea>
                    </div>

                    <div class="radio-wrapper">
                        <div class="radio">
                            <label for="female">
                                <input class="input-radio" id="female" name="gender" type="radio" value="female" checked />
                                <span>Female</span>
                            </label>
                        </div>
                        <div class="radio">
                            <label for="male">
                                <input class="input-radio" id="male" name="gender" type="radio" value="male" />
                                <span>Male</span>
                            </label>
                        </div>
                        <div class="radio">
                            <label for="unisex">
                                <input class="input-radio" id="unisex" name="gender" type="radio" value="unisex" />
                                <span>Unisex</span>
                            </label>
                        </div>
                    </div>

                    <div class="field center-align">
                        <p class="feedback error-light" v-if="feedback">
                            {{ feedback }}
                        </p>
                        <button class="btn-submit btn">Add Name</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
// import firebase database from firebase config file
import db from '@/firebase/init'

export default {
    name: 'AddMumblCard',
    props: ['editActive'],
    // local data
    data() {
        return {
            allNames: [],
            name: null,
            origin: null,
            meaning: null,
            gender: null,
            feedback: null,
            feedbackSuccess: null
        }
    },
    // local functions
    methods: {
        addMumblCard() {
            // get selected radio butoon and store it to local data
            this.getSelectedRadioBtn()
            // check if added name is alreay in database
            let isAlreadyInNames = this.allNames.includes(this.name)
            // if all input fields are filled
            if (this.name && this.origin && this.meaning && !isAlreadyInNames) {
                //push dragged name to local array allNames
                this.allNames.push(this.name)
                // reset feedback
                this.feedback = null

                //send local data to firestore
                db.collection('mumblCards').add({
                    name: this.name,
                    gender: this.gender,
                    origin: this.origin,
                    meaning: this.meaning,
                    editing: false
                })
                // after data is submitted reset local data
                .then(() => {
                    this.name = null
                    this.gender = null
                    this.origin = null
                    this.meaning = null
                    // feedback via toast
                    M.toast({
                        html: 'Name added',
                        displayLength: 3000,
                        classes: 'toast success'
                    })
                })
                // if something doesn't work aoutput an error in the console
                .catch(err => {
                    console.log(err);
                })
            }
            // if an inpult field is empty show specific error message
            else {
                if (!this.name) {
                    this.feedback = 'You must enter a name'
                }
                else if (isAlreadyInNames) {
                    this.feedback = 'This name already exists'
                }
                else if (!this.origin) {
                    this.feedback = 'You must enter the origin'
                }
                else {
                    this.feedback = 'You must enter the meaning'
                }
            }
        },
        getSelectedRadioBtn() {
            // select radio buttons
            let radio = document.querySelectorAll('.input-radio');
            // find checked radio button and store value to local data gender
            for(var i = 0; i < radio.length; i++) {
                if(radio[i].checked) {
                    this.gender = radio[i].value;
                }
            }
        }
    },
    // lifecycle-hook (fires before components are rendered)
    created() {
        // fetch data favorites from firestore
        db.collection('mumblCards').get()
        // when fetch data has completed
        .then(snapshot => {
            snapshot.forEach(doc => {
                let card = doc.data()
                this.allNames.push(card.name)
            })
        })
    }
}
</script>

<style lang="scss">

    .add-mumbl-card {
        max-width: 500px;

        .card {

            .feedback {
                margin-bottom: 1rem;
            }
        }

        form {
            .radio-wrapper {
                margin-bottom: 40px;
            }

            .radio {
                display: inline-block;
                margin-right: 16px;
            }
        }
    }


</style>



// WEBPACK FOOTER //
// src/components/backend/AddMumblCard.vue